<app-pageheader [Parent]="this">
  <app-form-save-button [Parent]="this" [Form]="Form" class="button is-primary" (OnSave)="Save()">
  </app-form-save-button>
</app-pageheader>

<app-loader [Parent]="this"></app-loader>
@if (FormLoaded) {
  <div [formGroup]="Form">
    <div class="columns">
      <div class="column is-6">
        <article class="panel">
          <p class="panel-heading">
            Citation Template Details
          </p>
          <div class="panel-block" style="display: block;">
            <app-field Label="Name">
              <div class="control">
                <input formControlName="Name" class="input" type="text" />
                <app-validator [For]="Form.get('Name')"></app-validator>
              </div>
            </app-field>
            <app-field Label="Description">
              <div class="control">
                <input formControlName="Description" class="input" type="text" />
                <app-validator [For]="Form.get('Description')"></app-validator>
              </div>
            </app-field>
            <app-field Label="Feed Lines Before Print">
              <div class="control">
                <input formControlName="FeedLinesBeforePrint" class="input" type="number" min="0" max="10" />
                <app-validator [For]="Form.get('FeedLinesBeforePrint')"></app-validator>
                <p class="help">Number of blank lines to feed before printing the citation.</p>
              </div>
            </app-field>
            <app-field Label="Feed Lines After Print">
              <div class="control">
                <input formControlName="FeedLinesAfterPrint" class="input" type="number" min="0" max="10" />
                <app-validator [For]="Form.get('FeedLinesAfterPrint')"></app-validator>
                <p class="help">Number of blank lines to feed after printing the citation.</p>
              </div>
            </app-field>
          </div>
        </article>
      </div>
    </div>
    <div class="columns">
      <div class="column is-12">
        <article class="panel">
          <div class="panel-heading" style="display: flex; justify-content: space-between; align-items: center;">
            <span>Template Lines</span>
            <div class="dropdown is-right" [ngClass]="{'is-active': showFormattingHelp}">
              <div class="dropdown-trigger">
                <button type="button" class="button is-small is-info is-light" (click)="toggleFormattingHelp($event)" title="Formatting Help">
                  <i class="fa fa-info-circle"></i>
                </button>
              </div>
              <div class="dropdown-menu" style="min-width: 320px;">
                <div class="dropdown-content" (click)="$event.stopPropagation()">
                  <div class="dropdown-item">
                    <p class="has-text-weight-bold mb-2">Text Formatting Options</p>
                    <table class="table is-fullwidth is-narrow">
                      <tbody>
                        <tr>
                          <td><code>[b]Bold Text[/b]</code></td>
                          <td><strong>Bold Text</strong></td>
                        </tr>
                        <tr>
                          <td><code>[i]Italic Text[/i]</code></td>
                          <td><em>Italic Text</em></td>
                        </tr>
                        <tr>
                          <td><code>[u]Underlined Text[/u]</code></td>
                          <td><u>Underlined Text</u></td>
                        </tr>
                        <tr>
                          <td><code>[st]Struck Text[/st]</code></td>
                          <td><span style="text-decoration: line-through;">Struck Text</span></td>
                        </tr>
                        <tr>
                          <td><code>[m]Medium Text[/m]</code></td>
                          <td><h2>Medium Text</h2></td>
                        </tr>
                        <tr>
                          <td><code>[l]Large Text[/l]</code></td>
                          <td><h1>Large Text</h1></td>
                        </tr>
                        <tr>
                          <td><code>[uc]Uppercase Text[/uc]</code></td>
                          <td>UPPERCASE TEXT</td>
                        </tr>
                        <tr>
                          <td><code>&#123;PropertyName&#125;</code></td>
                          <td>Inject Property</td>
                        </tr>
                        <tr>
                          <td><code>&#123;ParentProperty.PropertyName&#125;</code></td>
                          <td>Inject Child Property</td>
                        </tr>
                        <tr>
                          <td><code>&#123;if:booleanproperty&#125;SHOW THIS&#123;else&#125;[b]SHOW THIS[/b]&#123;endif&#125;</code></td>
                          <td>Toggle Based on Boolean</td>
                        </tr>
                        <tr>
                          <td><code>&#123;each:ChildCollection&#125;[b]Label&#125; &#123;ChildProperty&#125;&#123;endeach&#125;</code></td>
                          <td>Repeat Line For Each Child Item</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="panel-block">
            <div class="control" style="width: 100%;">
              @for (line of Model.Lines; track line; let i = $index) {
                <div class="mb-2">
                  <div class="template-line-row" [ngClass]="{'conditional-line-wrapper': line.LineType === 'text' && (hasOuterCondition(line.Content) || visibleConditionEditor === i)}">
                    <!-- Iteration builder strip ABOVE the line -->
                    @if (line.LineType === 'text' && visibleIterationEditor === i) {
                      <div class="condition-strip">
                        <span class="condition-label">FOR EACH</span>
                        <input class="input is-small condition-input"
                          type="text"
                          list="citation-collection-suggestions"
                          [(ngModel)]="iterationDraft.collectionPath"
                          [ngModelOptions]="{standalone: true}"
                          placeholder="CitationViolations" />
                          <datalist id="citation-collection-suggestions">
                            @for (p of suggestedCollectionProperties; track p) {
                              <option [value]="p"></option>
                            }
                          </datalist>
                          <span class="condition-label">LINE</span>
                          <input class="input is-small condition-text"
                            type="text"
                            [(ngModel)]="iterationDraft.bodyText"
                            [ngModelOptions]="{standalone: true}"
                            placeholder="Per-item text using &#123;ChildProperty&#125; tags" />
                            <button type="button" class="button is-small is-warning ml-2" (click)="applyIterationToLine(i)">
                              Apply
                            </button>
                            @if (hasIteration(line.Content)) {
                              <button
                                type="button"
                                class="button is-small is-danger is-light ml-1"
                                (click)="removeIterationFromLine(i)">
                                Remove foreach
                              </button>
                            }
                            <button type="button"
                              class="button is-small is-light ml-1"
                              (click)="toggleIterationEditor(i)">
                              ✕
                            </button>
                          </div>
                        }
                        <!-- Condition builder strip ABOVE the line -->
                        @if (line.LineType === 'text' && visibleConditionEditor === i) {
                          <div class="condition-strip">
                            <span class="condition-label">IF</span>
                            <input class="input is-small condition-input"
                              type="text"
                              list="citation-prop-suggestions"
                              [(ngModel)]="conditionDraft.propertyPath"
                              [ngModelOptions]="{standalone: true}"
                              placeholder="IsWarning" />
                              <datalist id="citation-prop-suggestions">
                                @for (p of suggestedProperties; track p) {
                                  <option [value]="p"></option>
                                }
                              </datalist>
                              <div class="select is-small condition-operator">
                                <select [(ngModel)]="conditionDraft.operator" [ngModelOptions]="{standalone: true}">
                                  @for (op of conditionOperators; track op) {
                                    <option [value]="op.value">{{op.label}}</option>
                                  }
                                </select>
                              </div>
                              @if (operatorRequiresValue(conditionDraft.operator)) {
                                <input
                                  class="input is-small condition-value"
                                  type="text"
                                  [(ngModel)]="conditionDraft.value"
                                  [ngModelOptions]="{standalone: true}"
                                  placeholder="true / 0 / Open" />
                              }
                              <span class="condition-label">THEN</span>
                              <div class="condition-text-wrapper" [ngClass]="{'format-container-active': visibleThenStyleIndex === i}">
                                @if (visibleThenStyleIndex !== i) {
                                  <ng-template [ngTemplateOutlet]=""></ng-template>
                                } @else {
                                  <div class="format-toolbar">
                                    <button type="button" class="button is-small is-white"
                                      [ngClass]="{'tag-button-active': isTagActive(conditionDraft.thenText, 'b')}"
                                      title="Bold" (click)="applyInlineTag(thenInput, 'b')">
                                      <span class="fmt-bold">B</span>
                                    </button>
                                    <button type="button" class="button is-small is-white"
                                      [ngClass]="{'tag-button-active': isTagActive(conditionDraft.thenText, 'i')}"
                                      title="Italic" (click)="applyInlineTag(thenInput, 'i')">
                                      <span class="fmt-italic">I</span>
                                    </button>
                                    <button type="button" class="button is-small is-white"
                                      [ngClass]="{'tag-button-active': isTagActive(conditionDraft.thenText, 'u')}"
                                      title="Underline" (click)="applyInlineTag(thenInput, 'u')">
                                      <span class="fmt-underline">U</span>
                                    </button>
                                    <button type="button" class="button is-small is-white"
                                      [ngClass]="{'tag-button-active': isTagActive(conditionDraft.thenText, 'st')}"
                                      title="Strikethrough" (click)="applyInlineTag(thenInput, 'st')">
                                      <span class="fmt-strike">S</span>
                                    </button>
                                    <button type="button" class="button is-small is-white"
                                      [ngClass]="{'tag-button-active': isTagActive(conditionDraft.thenText, 'm')}"
                                      title="Medium" (click)="applyInlineTag(thenInput, 'm')">
                                      <span class="fmt-medium">M</span>
                                    </button>
                                    <button type="button" class="button is-small is-white"
                                      [ngClass]="{'tag-button-active': isTagActive(conditionDraft.thenText, 'l')}"
                                      title="Large" (click)="applyInlineTag(thenInput, 'l')">
                                      <span class="fmt-large">L</span>
                                    </button>
                                    <button type="button" class="button is-small is-white"
                                      [ngClass]="{'tag-button-active': isTagActive(conditionDraft.thenText, 'uc')}"
                                      title="Uppercase" (click)="applyInlineTag(thenInput, 'uc')">
                                      <span class="fmt-uc">UC</span>
                                    </button>
                                  </div>
                                  <input #thenInput
                                    class="input is-small condition-text"
                                    type="text"
                                    [(ngModel)]="conditionDraft.thenText"
                                    [ngModelOptions]="{standalone: true}"
                                    (focus)="focusThenInput(i)"
                                    placeholder="Shown when true" />
                                  }
                                </div>
                                @if (conditionDraft.elseEnabled) {
                                  <span class="condition-label">ELSE</span>
                                  <div class="condition-text-wrapper" [ngClass]="{'format-container-active': visibleElseStyleIndex === i}">
                                    @if (visibleElseStyleIndex !== i) {
                                      <input
                                        type="text"
                                        class="input is-small condition-text"
                                        [ngClass]="getPreviewClasses(conditionDraft.elseText)"
                                        [value]="stripFormattingTags(conditionDraft.elseText)"
                                        readonly
                                        (click)="focusElseInput(i)"
                                        placeholder="Optional when false" />
                                      } @else {
                                        <div class="format-toolbar">
                                          <button type="button" class="button is-small is-white"
                                            [ngClass]="{'tag-button-active': isTagActive(conditionDraft.elseText, 'b')}"
                                            title="Bold" (click)="applyInlineTag(elseInput, 'b')">
                                            <span class="fmt-bold">B</span>
                                          </button>
                                          <button type="button" class="button is-small is-white"
                                            [ngClass]="{'tag-button-active': isTagActive(conditionDraft.elseText, 'i')}"
                                            title="Italic" (click)="applyInlineTag(elseInput, 'i')">
                                            <span class="fmt-italic">I</span>
                                          </button>
                                          <button type="button" class="button is-small is-white"
                                            [ngClass]="{'tag-button-active': isTagActive(conditionDraft.elseText, 'u')}"
                                            title="Underline" (click)="applyInlineTag(elseInput, 'u')">
                                            <span class="fmt-underline">U</span>
                                          </button>
                                          <button type="button" class="button is-small is-white"
                                            [ngClass]="{'tag-button-active': isTagActive(conditionDraft.elseText, 'st')}"
                                            title="Strikethrough" (click)="applyInlineTag(elseInput, 'st')">
                                            <span class="fmt-strike">S</span>
                                          </button>
                                          <button type="button" class="button is-small is-white"
                                            [ngClass]="{'tag-button-active': isTagActive(conditionDraft.elseText, 'm')}"
                                            title="Medium" (click)="applyInlineTag(elseInput, 'm')">
                                            <span class="fmt-medium">M</span>
                                          </button>
                                          <button type="button" class="button is-small is-white"
                                            [ngClass]="{'tag-button-active': isTagActive(conditionDraft.elseText, 'l')}"
                                            title="Large" (click)="applyInlineTag(elseInput, 'l')">
                                            <span class="fmt-large">L</span>
                                          </button>
                                          <button type="button" class="button is-small is-white"
                                            [ngClass]="{'tag-button-active': isTagActive(conditionDraft.elseText, 'uc')}"
                                            title="Uppercase" (click)="applyInlineTag(elseInput, 'uc')">
                                            <span class="fmt-uc">UC</span>
                                          </button>
                                        </div>
                                        <input #elseInput
                                          class="input is-small condition-text"
                                          type="text"
                                          [(ngModel)]="conditionDraft.elseText"
                                          [ngModelOptions]="{standalone: true}"
                                          (focus)="focusElseInput(i)"
                                          placeholder="Optional when false" />
                                        }
                                      </div>
                                    } @else {
                                      <ng-container *ngTemplateOutlet="addElseTemplate"></ng-container>
                                    }
                                    <ng-template #addElseTemplate>
                                      <button type="button" class="button is-small is-light" (click)="enableElse()">
                                        Add else
                                      </button>
                                    </ng-template>
                                    <button type="button" class="button is-small is-warning ml-2" (click)="applyConditionToLine(i)">
                                      Apply
                                    </button>
                                    @if (hasOuterCondition(line.Content)) {
                                      <button
                                        type="button"
                                        class="button is-small is-danger is-light ml-1"
                                        (click)="removeConditionFromLine(i)">
                                        Remove condition
                                      </button>
                                    }
                                    <button type="button"
                                      class="button is-small is-light ml-1"
                                      (click)="toggleConditionEditor(i)">
                                      ✕
                                    </button>
                                  </div>
                                }
                                <!-- Main line row - compact, flex-based layout -->
                                <div class="template-line-main">
                                  <div class="line-controls">
                                    @if (line.LineType === 'text') {
                                      <button
                                        type="button"
                                        class="button is-small line-icon-button"
                                        [ngClass]="hasOuterCondition(line.Content) ? 'is-warning is-light' : 'is-white'"
                                        (click)="toggleConditionEditor(i)"
                                        [title]="hasOuterCondition(line.Content) ? 'Edit Condition' : 'Add Condition'">
                                        <i class="fa fa-filter"></i>
                                      </button>
                                    }
                                    @if (line.LineType === 'text') {
                                      <button
                                        type="button"
                                        class="button is-small line-icon-button"
                                        [ngClass]="hasIteration(line.Content) ? 'is-link is-light' : 'is-white'"
                                        (click)="toggleIterationEditor(i)"
                                        title="Repeat for each child item">
                                        <i class="fa fa-list-ol"></i>
                                      </button>
                                    }
                                    <button
                                      type="button"
                                      class="button is-small line-icon-button"
                                      (click)="moveLineUp(i)"
                                      [disabled]="i === 0"
                                      title="Move Up">
                                      <i class="fa fa-arrow-up"></i>
                                    </button>
                                    <button
                                      type="button"
                                      class="button is-small line-icon-button"
                                      (click)="moveLineDown(i)"
                                      [disabled]="i === Model.Lines.length - 1"
                                      title="Move Down">
                                      <i class="fa fa-arrow-down"></i>
                                    </button>
                                    <span class="tag is-light line-index-tag">
                                      {{ i + 1 }}
                                    </span>
                                    @if (line.LineType === 'barcode') {
                                      <button
                                        type="button"
                                        class="button is-small line-icon-button"
                                        (click)="toggleBarcodeSettings(i)"
                                        [ngClass]="{'is-info': visibleBarcodeSettings === i}"
                                        title="Barcode settings">
                                        <i class="fa fa-barcode"></i>
                                        <i class="fa fa-cog ml-1 is-size-7"></i>
                                      </button>
                                    }
                                    @if (line.LineType === 'text') {
                                      <div class="line-align-select">
                                        <button
                                          type="button"
                                          class="button is-small line-icon-button"
                                          [ngClass]="{'line-align-selected': line.Alignment === 0}"
                                          (click)="line.Alignment = 0; Form.markAsDirty()"
                                          title="Align left">
                                          <i class="fa fa-align-left"></i>
                                        </button>
                                        <button
                                          type="button"
                                          class="button is-small line-icon-button"
                                          [ngClass]="{'line-align-selected': line.Alignment === 1}"
                                          (click)="line.Alignment = 1; Form.markAsDirty()"
                                          title="Align center">
                                          <i class="fa fa-align-center"></i>
                                        </button>
                                        <button
                                          type="button"
                                          class="button is-small line-icon-button"
                                          [ngClass]="{'line-align-selected': line.Alignment === 2}"
                                          (click)="line.Alignment = 2; Form.markAsDirty()"
                                          title="Align right">
                                          <i class="fa fa-align-right"></i>
                                        </button>
                                      </div>
                                    }
                                  </div>
                                  <div class="line-content-wrapper">
                                    @if (!hasOuterCondition(line.Content)) {
                                      @if (visibleLineStyleIndex !== i) {
                                        <input
                                          type="text"
                                          class="input is-fullwidth"
                                          [ngClass]="getPreviewClasses(line.Content)"
                                          [value]="stripFormattingTags(line.Content)"
                                          readonly
                                          (click)="focusLineInput(i)"
                                          placeholder="Line content" />
                                        } @else {
                                          <div class="input-with-format" [ngClass]="{'format-container-active': visibleLineStyleIndex === i}">
                                            @if (visibleLineStyleIndex === i) {
                                              <div class="format-toolbar">
                                                <button
                                                  type="button"
                                                  class="button is-small is-white"
                                                  [ngClass]="{'tag-button-active': isTagActive(line.Content, 'b')}"
                                                  title="Bold"
                                                  (click)="applyInlineTag(lineInput, 'b')">
                                                  <span class="fmt-bold">B</span>
                                                </button>
                                                <button
                                                  type="button"
                                                  class="button is-small is-white"
                                                  [ngClass]="{'tag-button-active': isTagActive(line.Content, 'i')}"
                                                  title="Italic"
                                                  (click)="applyInlineTag(lineInput, 'i')">
                                                  <span class="fmt-italic">I</span>
                                                </button>
                                                <button
                                                  type="button"
                                                  class="button is-small is-white"
                                                  [ngClass]="{'tag-button-active': isTagActive(line.Content, 'u')}"
                                                  title="Underline"
                                                  (click)="applyInlineTag(lineInput, 'u')">
                                                  <span class="fmt-underline">U</span>
                                                </button>
                                                <button
                                                  type="button"
                                                  class="button is-small is-white"
                                                  [ngClass]="{'tag-button-active': isTagActive(line.Content, 'st')}"
                                                  title="Strikethrough"
                                                  (click)="applyInlineTag(lineInput, 'st')">
                                                  <span class="fmt-strike">S</span>
                                                </button>
                                                <button
                                                  type="button"
                                                  class="button is-small is-white"
                                                  [ngClass]="{'tag-button-active': isTagActive(line.Content, 'm')}"
                                                  title="Medium"
                                                  (click)="applyInlineTag(lineInput, 'm')">
                                                  <span class="fmt-medium">M</span>
                                                </button>
                                                <button
                                                  type="button"
                                                  class="button is-small is-white"
                                                  [ngClass]="{'tag-button-active': isTagActive(line.Content, 'l')}"
                                                  title="Large"
                                                  (click)="applyInlineTag(lineInput, 'l')">
                                                  <span class="fmt-large">L</span>
                                                </button>
                                                <button
                                                  type="button"
                                                  class="button is-small is-white"
                                                  [ngClass]="{'tag-button-active': isTagActive(line.Content, 'uc')}"
                                                  title="Uppercase"
                                                  (click)="applyInlineTag(lineInput, 'uc')">
                                                  <span class="fmt-uc">UC</span>
                                                </button>
                                              </div>
                                            }
                                            <input
                                              #lineInput
                                              type="text"
                                              class="input is-fullwidth"
                                              [(ngModel)]="line.Content"
                                              [ngModelOptions]="{standalone: true}"
                                              (ngModelChange)="Form.markAsDirty()"
                                              (focus)="focusLineInput(i)"
                                              placeholder="Line content">
                                            </div>
                                          }
                                        } @else {
                                          @if (hasElseBranch(line.Content)) {
                                            <div class="conditional-preview-group" (click)="toggleConditionEditor(i)">
                                              <input
                                                type="text"
                                                class="input"
                                                [ngClass]="getPreviewClasses(extractThenText(line.Content))"
                                                [value]="stripFormattingTags(extractThenText(line.Content))"
                                                readonly />
                                                <button class="button is-static"><strong>OR</strong></button>
                                                <input
                                                  type="text"
                                                  class="input"
                                                  [ngClass]="getPreviewClasses(extractElseText(line.Content))"
                                                  [value]="stripFormattingTags(extractElseText(line.Content))"
                                                  readonly />
                                                </div>
                                              } @else {
                                                <input
                                                  type="text"
                                                  class="input is-fullwidth"
                                                  [ngClass]="getPreviewClasses(extractThenText(line.Content))"
                                                  [value]="stripFormattingTags(extractThenText(line.Content))"
                                                  readonly
                                                  (click)="toggleConditionEditor(i)"
                                                  placeholder="Text when condition is true (edit via condition above)" />
                                                }
                                              }
                                            </div>
                                            <div class="line-actions">
                                              <button
                                                type="button"
                                                class="button is-small is-danger is-light line-icon-button"
                                                (click)="removeLine(i)"
                                                title="Remove Line">
                                                <i class="fa fa-trash"></i>
                                              </button>
                                            </div>
                                          </div>
                                          <!-- Barcode specific options -->
                                          @if (line.LineType === 'barcode' && visibleBarcodeSettings === i) {
                                            <div class="ml-5 mt-1 pl-2 pr-2 pt-1 pb-1" style="border-left: 3px solid #3298dc; background-color: #f8fafc;">
                                              <div class="is-flex is-flex-wrap-wrap is-align-items-center" style="gap: 0.5rem;">
                                                <div class="is-flex is-align-items-center mr-2">
                                                  <label class="label is-small mb-0 mr-1">Type:</label>
                                                  <div class="select is-small">
                                                    <select [(ngModel)]="line.BarcodeType" [ngModelOptions]="{standalone: true}" (ngModelChange)="Form.markAsDirty()">
                                                      @for (type of barcodeTypes; track type) {
                                                        <option [value]="type.value">{{type.label}}</option>
                                                      }
                                                    </select>
                                                  </div>
                                                </div>
                                                <div class="is-flex is-align-items-center mr-2">
                                                  <label class="label is-small mb-0 mr-1">Orientation:</label>
                                                  <div class="select is-small">
                                                    <select [(ngModel)]="line.Orientation" [ngModelOptions]="{standalone: true}" (ngModelChange)="Form.markAsDirty()">
                                                      @for (orientation of barcodeOrientations; track orientation) {
                                                        <option [value]="orientation.value">{{orientation.label}}</option>
                                                      }
                                                    </select>
                                                  </div>
                                                </div>
                                                <div class="is-flex is-align-items-center mr-2">
                                                  <label class="label is-small mb-0 mr-1">Title:</label>
                                                  <div class="select is-small">
                                                    <select [(ngModel)]="line.ShowHumanReadableTitle" [ngModelOptions]="{standalone: true}" (ngModelChange)="Form.markAsDirty()">
                                                      @for (setting of humanReadableSettings; track setting) {
                                                        <option [value]="setting.value">{{setting.label}}</option>
                                                      }
                                                    </select>
                                                  </div>
                                                </div>
                                                <div class="is-flex is-align-items-center mr-2">
                                                  <label class="label is-small mb-0 mr-1">W:</label>
                                                  <div style="width: 70px;">
                                                    <input type="number" class="input is-small" [(ngModel)]="line.Width" [ngModelOptions]="{standalone: true}" (ngModelChange)="Form.markAsDirty()" min="50" max="400">
                                                  </div>
                                                  <span class="ml-1 has-text-grey is-size-7">px</span>
                                                </div>
                                                <div class="is-flex is-align-items-center">
                                                  <label class="label is-small mb-0 mr-1">H:</label>
                                                  <div style="width: 70px;">
                                                    <input type="number" class="input is-small" [(ngModel)]="line.Height" [ngModelOptions]="{standalone: true}" (ngModelChange)="Form.markAsDirty()" min="20" max="200">
                                                  </div>
                                                  <span class="ml-1 has-text-grey is-size-7">px</span>
                                                </div>
                                              </div>
                                            </div>
                                          }
                                        </div>
                                      </div>
                                    }
                                    <div class="buttons mt-2">
                                      <button type="button" class="button is-primary is-outlined" (click)="addTextLine()">
                                        <i class="fa fa-font mr-1"></i> Add Text Line
                                      </button>
                                      <button type="button" class="button is-info is-outlined" (click)="addBarcodeLine()">
                                        <i class="fa fa-barcode mr-1"></i> Add Barcode Line
                                      </button>
                                    </div>
                                    @if (Model.Lines.length === 0) {
                                      <div class="notification is-warning mt-2">
                                        At least one template line is required.
                                      </div>
                                    }
                                  </div>
                                </div>
                              </article>
                            </div>
                          </div>
                        </div>
                      }